import { Divider } from '@cleartrip/bento/components/Divider'
import { Cross } from '@cleartrip/bento/components/Icon/iconComponents/Cross'
import { Spacer } from '@cleartrip/bento/components/Spacing'
import Modal from 'lib/Modal'

import React, { useState, useEffect } from 'react'
import { DOMAIN } from 'constants/base'

const FeatureWidgetModal = ({ modalData = {}, close = {} }) => {
    const FAQ = modalData?.FAQ
    let footerTextArr = modalData?.footerText.split('FAQs page')
    return (
        <Modal isShowing={open} overlayClassName="z-80 bg-white">
            <div className='flex flex-column z-80 bg-white p-6 br-12'
                style={{ width: '825px' }}
            >
                <Cross className='c-pointer' height={20} width={20} fill='#1A1A1A' onClick={close} />
                <Spacer className='pt-4' />
                <div>
                    <img
                        src={modalData?.modalIcon}
                        alt='Medi Cancel Logo'
                    />
                </div>
                <Spacer className='pt-4' />
                <div className='c-neutral-500 fw-600'>{modalData?.title}</div>
                <Spacer className='pt-1'/>
                <div className='fs-6 fw-600'>{modalData?.subtext}</div>
                <Divider className='pt-4' style={{ borderWidth: '1px' }} />
                <div className='flex flex-wrap mt-4'>
                    {FAQ.map(item => {
                        return (
                            <div className='flex flex-column w-50p'>
                                <div className='fs-4 fw-600 pb-2 w-90p'>
                                    {item.q}
                                </div>
                                <div className='fs-3 fw-400 pb-6 w-90p'>
                                    {item.a}
                                </div>
                            </div>
                        )
                    })

                    }
                </div>
                <Divider className='mb-4' style={{ borderWidth: '1px' }} />
                <div>
                    <div>
                        {footerTextArr.length > 1 ?
                            (
                                <span>
                                    {footerTextArr[0]}
                                    <a className='c-blue c-pointer' href={`${DOMAIN}${modalData?.link}`}>FAQs page</a>
                                    {footerTextArr[1]}
                                </span>
                            )
                            :
                            <span>
                                {footerTextArr[0]}
                            </span>

                        }
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default FeatureWidgetModal